/**
 * All 16 admin permission strings (mirrors backend Admin model enum).
 * Single source of truth for frontend permission checks and UI grouping.
 */
export const ALL_PERMISSIONS = [
  'manage_users',
  'manage_drivers',
  'manage_rides',
  'manage_payments',
  'manage_support',
  'manage_settings',
  'manage_settings_pricing',
  'manage_settings_fleet',
  'manage_settings_safety',
  'manage_settings_support',
  'manage_settings_zones',
  'manage_promotions',
  'manage_broadcasts',
  'view_analytics',
  'manage_admins',
  'view_audit_logs',
];

/**
 * Grouped permission display — used in the Admins page permission editor.
 * Extracted from Settings.js STAFF_PERMISSION_GROUPS (now canonical here).
 */
export const PERMISSION_GROUPS = [
  {
    label: 'Users & Drivers',
    permissions: ['manage_users', 'manage_drivers'],
  },
  {
    label: 'Operations',
    permissions: ['manage_rides', 'manage_payments', 'manage_support'],
  },
  {
    label: 'Settings',
    permissions: [
      'manage_settings',
      'manage_settings_pricing',
      'manage_settings_fleet',
      'manage_settings_safety',
      'manage_settings_support',
      'manage_settings_zones',
    ],
  },
  {
    label: 'Marketing',
    permissions: ['manage_promotions', 'manage_broadcasts'],
  },
  {
    label: 'Analytics & Admin',
    permissions: ['view_analytics', 'manage_admins', 'view_audit_logs'],
  },
];

export const ADMIN_ROLES = ['super_admin', 'admin', 'support', 'analyst'];
